import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Route , withRouter} from 'react-router-dom';

const NavigationBlock = inject("stores") (
    observer (
        class NavigationBlock extends Component {
            constructor(props) {
                super(props);
                this.props = props;
                this.urlAPI = process.env.REACT_APP_URL_API;
                this.storeUi = this.props.stores.storeUi;

                this.state = {
                    view: this.props.view
                }
            }

            handleBrand = (brand) => {
                this.setState({
                    brand: brand
                });
                const url = "/" + this.props.section + "/" + brand;
                this.props.history.push(url);
            }

            handleBrands = (section) => {
                const url = "/" + section + "/";
                this.props.history.push(url);
            }

            render() {
                return (
                    <div className="block--navigation">
                        <div className="block--navigation__header">
                            <span className="block--navigation__title --link" onClick={() => this.handleBrands(this.props.section)}>{this.props.section}</span>
                        </div>
                        <div className="block--navigation__brands">
                            <ul className="block--navigation__list">
                                {this.storeUi.sub_nav.map((nav_item) => (
                                    nav_item.name === this.props.section &&
                                        nav_item.values.map((item) => (
                                            parseInt(item.active) === 1 && 
                                            <li className="block--navigation__listitem --link" onClick={() => this.handleBrand(item.name)}>
                                                 <img src={this.urlAPI + "/adam/public/images/brands/clean/logo-" + item.name + "-trans.png"} />
                                            </li>
                                        ))
                                    
                                ))}
                            </ul>
                        </div>
                    </div>
                );
            }
        }
    )
)

export default withRouter(NavigationBlock);
